import './Product';
import './Region';
import './Market';
import './Segment';

export { default as DomainRegistry } from './DomainRegistry';
export type { IDomainDictionaries } from './DomainRegistry';
